try {
    $(window).on("load", function(){
        if(Cookies.get('cws-booked') != null){
            // Already sent a booked notification 
        } else {
            fbq('track', 'Schedule');
            console.log("Facebook Scheduled Event Sent");
            Cookies.set("cws-booked", 1, { expires: 1 });
        }
    });
} catch (error) {
    console.error(error);
}